import { cn } from '@/utils/cn'
import { cva, type VariantProps } from 'class-variance-authority'
import { LucideIcon } from 'lucide-react'
import { forwardRef } from 'react'

const iconTileVariants = cva('text-white p-2 rounded shadow inline-block', {
  variants: {
    size: {
      default: '[&_svg]:size-8',
      sm: 'p-1 [&_svg]:size-4',
    },
  },
  defaultVariants: {
    size: 'default',
  },
})

export interface IconTileProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof iconTileVariants> {
  color: string
  Icon: LucideIcon
}

export const IconTile = forwardRef<HTMLDivElement, IconTileProps>(({ size, className, color, Icon, ...props }, ref) => {
  return (
    <div ref={ref} {...props} style={{ backgroundColor: color }} className={cn(iconTileVariants({ size, className }))}>
      <Icon strokeWidth={1.5} />
    </div>
  )
})
